import {Component, OnInit} from '@angular/core';
import {SpecificationsMapped} from '../models/specification-mapped';
import {NgxSpinnerService} from 'ngx-spinner';
import {WholesaleService} from '../service/wholesale.service';
import {UserService} from '../service/user.service';
import {BulkOrderService} from '../service/bulk-order-service';
import {WholesaleMessageService} from '../service/wholesale-message.service';
import {HttpErrorInterceptor} from '../service/http-error.interceptor';
import {WholesaleConstants} from '../constants/wholesale.constants';
import {formatDate} from '@angular/common';
import {DealerResponse} from '../models/dealer-details';
import {ProductionOfferResponse} from '../models/production-offer-response.model';
import {WholesaleResponse} from '../models/wholesale-response.model';
import {DealerEntityGroupMixRequest} from '../models/dealer-group-mix-request';
import {DealerEntityMixSpecification} from '../models/dealer-mix-specification';
import {DealerEntityMixRequestWrapper} from '../models/dealer-group-mix-request-wrapper';

@Component({
	standalone: false,
	selector: 'app-dealer-mix-volume',
	templateUrl: './dealer-mix-volume.component.html',
	styleUrls: ['./dealer-mix-volume.component.css']
})
export class DealerMixVolumeComponent implements OnInit {
	public dealerId: string;
	public dealerName: string;
	public dealerType: string;
	public vehicleLinesList: any[];
	public specificationsMapped: SpecificationsMapped[] = [];
	public existingList: any[] = [];
	public entityVolumeAllocatedNameplateList: any[] = [];
	public selectedVehicle: any;
	public errorMsg: string;
	public errorMsgList: string[];
	public first = 0;
	public pageSize = 10;
	public showDealerDetailDiv = false;
	public wholesaleCurrentMonth: any;
	dealerSpecificMix: any;
	public commitmentCount = 0;
	totalEntityMix: number;
	dealerEntityGroupMixRequestList: DealerEntityGroupMixRequest[] = [];
	dealerRequest: DealerResponse[] = [];

	wholesaleCommitmentResponseList;
	showTableFlag: boolean;
	public groupTotal: number;
	currentYearAndMonth: number;
	public isNoRecordFound = false;
	isServerError: boolean;
	siteCode: string;
	public isApproved = false;
	wholesaleCurrentMonthAndYear: any;
	public wholesaleDealerViewData: string;
	public selectAllForCopy: boolean;
	public isCopyAllChecked: boolean;
	prodOfferEntityResponse :any;
	noVolumesAllocated: boolean = false;
	noVolumesAllocatedMessage: string = "No Volumes Allocated for the dealer this month yet";
	public wholesaleStatusMonth: string;
	public isStatus: boolean;
	public wholesaleStatus = false;
	public commitButtonDisable = false;
	public commitStatus: string;

	constructor(public spinner: NgxSpinnerService,
				private wholesaleService: WholesaleService,
				private userService: UserService,
				private bulkOrderService: BulkOrderService,
				private wholesaleMessageService: WholesaleMessageService,
				private httpInterceptorService: HttpErrorInterceptor) {
	}

	ngOnInit() {
		this.registerErrorHandler();
		this.showTableFlag = false;
		this.spinner.show();
		this.wholesaleCommitmentResponseList = [];
		this.siteCode = sessionStorage.getItem('loggedInSiteCode');
		this.wholesaleCurrentMonth = this.transformDate(new Date(), WholesaleConstants.dateFormatMMMMYYYY);
		this.wholesaleCurrentMonthAndYear = this.transformDate(new Date().setMonth(new Date().getMonth()), WholesaleConstants.dateFormatYYYYMM);
		this.bulkOrderService.getVehicleLineBoc(true).subscribe(vechileLineData => {
			this.vehicleLinesList = JSON.parse(JSON.stringify(vechileLineData)).vehicleLineResponse;
		});
		this.currentYearAndMonth = Number(this.transformDate(new Date().setMonth(new Date().getMonth()), 'yyyyMM'));
		this.isServerError = false;
		this.getWholesaleStatus();
		this.getWholesaleDealerDetail(this.siteCode);
	}

	public transformDate(date: string | number | Date, pattern: string) {
		return formatDate(date, pattern, 'en-US');
	}

	getSpecificationsByVehicleLine() {

		this.isServerError = false;
		if (this.selectedVehicle) {
			this.spinner.show();
			this.errorMsgList = [];
			this.errorMsg = '';
			this.specificationsMapped = [];
			this.commitmentCount = 0;
			this.isApproved = false;

			this.prodOfferEntityResponse.dealerProductionOfferEntityList.forEach(dealerProductionOfferEntity => {
				this.commitmentCount = this.commitmentCount + dealerProductionOfferEntity.entityVolume;
			});
			this.bulkOrderService.getSpecificationsAndMixMapped(
				sessionStorage.getItem('loggedInUserMarketCode'),
				this.selectedVehicle.namePlateId, this.currentYearAndMonth,
				this.selectedVehicle.productionMonth, sessionStorage.getItem('loggedInSiteCode'), this.prodOfferEntityResponse)
				.subscribe(data => {
					if (data && data.specifications && data.specifications.length === 0) {
						this.spinner.hide();
						this.isServerError = true;
						this.errorMsg = WholesaleConstants.noSpecificationsMappedForGivenVehicleLine;
						this.existingList = data.specifications;
						this.specificationsMapped = data.specifications;
						this.groupTotal = data.allocationCommitted;
						return;
					}

					this.existingList = data.specifications;
					this.specificationsMapped = data.specifications;
					this.groupTotal = data.allocationCommitted;
					this.spinner.hide();
					this.showTableFlag = true;
					this.refreshTotalEntityMixCalculated();
				});
		}
	}

	refreshTotalEntityMixCalculated() {
		let totalEntityMix = 0;
		if (this.specificationsMapped && this.specificationsMapped.length > 0) {
			this.specificationsMapped.forEach(specification => {
				if (specification.volume != undefined) {
					totalEntityMix += specification.volume;
				}
			});
		}
		this.totalEntityMix = totalEntityMix;
	}

	submitAllocationVolume() {
		this.dealerEntityGroupMixRequestList = [];
		this.isServerError = false;
		if (this.selectedVehicle === undefined || this.selectedVehicle === null) {
			this.wholesaleMessageService.showMesssge(WholesaleConstants.selectVehicleLineFirst, WholesaleConstants.error);
		} else {
			const dealerMixSpecificationList: DealerEntityMixSpecification[] = [];
			const dealerEntityGroupMixRequest = new DealerEntityGroupMixRequest();
			//Look at this code
			dealerEntityGroupMixRequest.dealerId = this.dealerRequest[0].dealerId;
			dealerEntityGroupMixRequest.volume = this.commitmentCount;
			for (const element of this.specificationsMapped) {
				if (element.volume > 0) {
					const dealerMixSpecification = new DealerEntityMixSpecification();
					dealerMixSpecification.specification = element.specificationKey;
					dealerMixSpecification.volume = element.volume;
					dealerMixSpecification.entityCode = element.code;
					dealerMixSpecificationList.push(dealerMixSpecification);
				}
			}
			if (dealerMixSpecificationList.length === 0) {
				this.wholesaleMessageService.showMesssge(WholesaleConstants.noDealerMixAvailable, WholesaleConstants.error);
			}
			else {
				this.spinner.show();
				dealerEntityGroupMixRequest.specifications = dealerMixSpecificationList;
				dealerEntityGroupMixRequest.dealerType = this.dealerRequest[0].dealerType;
				this.dealerEntityGroupMixRequestList.push(dealerEntityGroupMixRequest);
				const dealerEntityMixRequestWrapper = new DealerEntityMixRequestWrapper();
				dealerEntityMixRequestWrapper.dealerEntityGroupMixRequest = this.dealerEntityGroupMixRequestList;
				dealerEntityMixRequestWrapper.userId = sessionStorage.getItem('cdsId');
				dealerEntityMixRequestWrapper.marketKey = sessionStorage.getItem('loggedInUserMarketCode');
				dealerEntityMixRequestWrapper.vehicleLineCode = this.selectedVehicle.namePlateId;
				dealerEntityMixRequestWrapper.wholesaleMonth = this.currentYearAndMonth;
				dealerEntityMixRequestWrapper.productionMonth = this.selectedVehicle.productionMonth;
				dealerEntityMixRequestWrapper.ptvl = this.selectedVehicle.ptvl;
				dealerEntityMixRequestWrapper.modelYear = this.selectedVehicle.marketingModelYear;

				this.errorMsgList = [];
				this.errorMsg = '';

				this.wholesaleService.saveDealerMixByMarketAndVehicleLine(dealerEntityMixRequestWrapper)
					.subscribe(data => {
						this.bulkOrderService.getSpecificationsAndMixMapped(
							sessionStorage.getItem('loggedInUserMarketCode'),
							this.selectedVehicle.namePlateId, this.currentYearAndMonth,
							this.selectedVehicle.productionMonth, sessionStorage.getItem('loggedInSiteCode'), this.prodOfferEntityResponse)
							.subscribe(data => {
								if (data && data.specifications && data.specifications.length === 0) {
									this.spinner.hide();
									this.isServerError = true;
									this.errorMsg = WholesaleConstants.noSpecificationsMappedForGivenVehicleLine;
									this.existingList = data.specifications;
									this.specificationsMapped = data.specifications;
									this.groupTotal = data.allocationCommitted;
									return;
								}
								this.existingList = data.specifications;
								this.specificationsMapped = data.specifications;
								this.groupTotal = data.allocationCommitted;
								this.showTableFlag = true;
								this.refreshTotalEntityMixCalculated();
								this.spinner.hide();
							});
						this.wholesaleMessageService.showMesssge(WholesaleConstants.dealermixsuccessfullyUpdated, WholesaleConstants.success);
						});
			}
		}
	}

	private registerErrorHandler() {
		this.httpInterceptorService.errorStream$().subscribe(errorObj => {
			const url: string = errorObj.url;
			if (!url.includes('WholesaleCommitmentService')) {
				const response = this.isJson(errorObj.error) ? JSON.parse(errorObj.error) : errorObj.error;
				this.isServerError = true;
				let errMessage;
				if (response instanceof ArrayBuffer) {
					errMessage = response;
				} else if (this.isJson(response.error.messages[0])) {
					errMessage = JSON.parse(response.error.messages[0]);
				} else {
					errMessage = response.error.messages[0];
				}

				if (errMessage.error) {
					this.errorMsg = errMessage.message;
					this.errorMsgList = this.errorMsg.split(',');
				} else if (!(errMessage instanceof Object)) {
					this.errorMsg = errMessage;
					this.errorMsgList = this.errorMsg.split(',');
				} else {
					this.errorMsg = errorObj.statusText;
					this.errorMsgList = this.errorMsg.split(',');
				}
			} else {
				this.isServerError = true;
				if (errorObj.error.error) {
					this.errorMsg = errorObj.error.message;
					this.errorMsgList = this.errorMsg.split(',');
				} else if (!(errorObj.error instanceof Object)) {
					this.errorMsg = errorObj.error;
					this.errorMsgList = this.errorMsg.split(',');
				} else {
					this.errorMsg = errorObj.statusText;
					this.errorMsgList = this.errorMsg.split(',');
				}
			}
			this.spinner.hide();
		});
	}

	private isJson(req): boolean {
		try {
			JSON.parse(req);
			return true;
		} catch (err) {
			return false;
		}
	}

	public getWholesaleDealerDetail(dealerId: string) {
		this.wholesaleService.getDealerDetails(null, null, null, dealerId).subscribe((
			dealerResponse: DealerResponse[]) => {
				this.dealerRequest = dealerResponse;
				if(dealerResponse.length > 0) {
					this.dealerId = this.dealerRequest[0].dealerId;
					this.dealerName = this.dealerRequest[0].dealerName;
					this.dealerType = this.dealerRequest[0].dealerType;
				} else {
					this.dealerId = dealerId;
					this.isNoRecordFound = true;
				}
				this.showDealerDetailDiv = true;
				this.wholesaleService.getProductionOfferEntitiesFromDealerRequest(dealerResponse, this.wholesaleCurrentMonthAndYear)
					.subscribe((response: ProductionOfferResponse[]) => {
					this.prodOfferEntityResponse = response;
					if(this.prodOfferEntityResponse.dealerProductionOfferEntityList.length === 0) {
						this.spinner.hide();
						this.noVolumesAllocated = true;
						return;
					}
					this.prodOfferEntityResponse.dealerProductionOfferEntityList.forEach(dealerProductionOfferEntity => {
						this.entityVolumeAllocatedNameplateList.push(dealerProductionOfferEntity.namePlateId)
					});
					const entityVolumeAllocatedVLcodes = new Set(this.entityVolumeAllocatedNameplateList);
					this.vehicleLinesList = this.vehicleLinesList.filter(vehicle => {
						return entityVolumeAllocatedVLcodes.has(vehicle.namePlateId)
					});
					this.spinner.hide();
				}, error => {
					this.spinner.hide();
				});
		});
	}

	copyOver() {
		for (const element of this.specificationsMapped) {
			if (element.allocatedVolume != undefined && element.allocatedVolume > 0) {
				element.volume = element.allocatedVolume;
				element.isChecked = true;
			}
		}
		 this.checkIfAllSelectedSync();
	}

	handleSelectAll() {
		for (const element of this.specificationsMapped) {
			element.isChecked = this.selectAllForCopy;
			element.volume = element.isChecked ? (element.allocatedVolume || 0) : 0;
		}
	}

	public checkIfAllSelected(selectedItem: SpecificationsMapped) {
		selectedItem.volume = selectedItem.isChecked ? (selectedItem.allocatedVolume || 0) : 0;
    	this.checkIfAllSelectedSync();
	}

	private checkIfAllSelectedSync() {
		if (this.specificationsMapped.length === 0) {
			this.selectAllForCopy = false;
			return;
		}
		this.selectAllForCopy = this.specificationsMapped.every(item => item.isChecked === true);
	}

	public getWholesaleStatus() {
		this.wholesaleService.getWholesaleStatus().subscribe(response => {
			this.wholesaleStatus = response.wholesaleStatus;
			this.wholesaleStatusMonth = response.month;
			if(this.wholesaleStatusMonth === this.wholesaleCurrentMonthAndYear) {
				this.isStatus = true;
			}
			this.toggleCommitButton(this.wholesaleStatus);
		});
	}

	public toggleCommitButton(isWholesaleStatus: boolean) {
		if (!isWholesaleStatus) {
			this.commitButtonDisable = true;
			this.commitStatus = WholesaleConstants.commitStatusMsg;
		} else {
			this.commitStatus = '';
			this.commitButtonDisable = false;
		}
	}
}
